(function (designWidth) {
  function computrFont () {
    const winW = document.documentElement.clientWidth
    if (winW >= 1920) { // PC端
      document.documentElement.style.fontSize = '100px'
      return
    }
    if (winW <= 1280) { // ipad or mobile
      document.documentElement.style.fontSize =
          (1280 / designWidth) * 100 + 'px'
      return
    }
    document.documentElement.style.fontSize =
        (winW / designWidth) * 100 + 'px'
  }
  computrFont()
  window.addEventListener('resize', computrFont) // 网页窗口变化自适应监听函数
})(1920)
